import { render, staticRenderFns } from "./AgentandExtension.vue?vue&type=template&id=f1bfb858&"
import script from "./AgentandExtension.vue?vue&type=script&lang=js&"
export * from "./AgentandExtension.vue?vue&type=script&lang=js&"
import style0 from "./AgentandExtension.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports